<tr *ngIf="discountPrice">
  <td [translate]="'receipt.discount'"></td>
  <td colspan="3" class="text-end">
    {{discountPrice | currencyFormat: currency}}
  </td>
</tr>
